import React, { useState } from "react";

const AgreementDetails = ({ agreementdetails }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Function to toggle visibility
  const toggleVisibility = () => {
    setIsOpen((prev) => !prev);
  };

  // Function to handle keyboard events (ArrowDown)
  const handleKeyPress = (event) => {
    if (event.key === "ArrowDown") {
      setIsOpen(true);
    }
  };

  // Function to format values
  const formatValue = (key, value) => {
    if (value === null || value === undefined) return null; // Skip null values

    // Fields that should have ₹ as a prefix
    const currencyFields = ["monthly_rent", "maintenance", "parking_charges", "brokerage", "security_deposit"];

    // Fields that should have 'months' as a suffix
    const monthFields = ["lock_in_period"];

    // Apply prefix and suffix conditionally
    const prefix = currencyFields.includes(key) ? "₹" : "";
    const suffix = monthFields.includes(key) ? " months" : "";

    // Convert numbers to Indian currency format if it's a currency field
    if (currencyFields.includes(key) && typeof value === "number") {
      value = value.toLocaleString("en-IN"); // Converts 4000000 to "40,00,000"
    }

    return `${prefix}${value}${suffix}`;
  };

  // Function to format field names (capitalize and replace _ with space)
  const formatFieldName = (fieldName) => {
    return fieldName
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
  };

  // Function to check if a section contains only null values
  const hasNonNullValues = (section) => {
    return Object.values(section || {}).some((value) => value !== null);
  };

  const showMonthlyCharges = hasNonNullValues(agreementdetails.monthly_charges);
  const showOneTimeCharges = hasNonNullValues(agreementdetails.one_time_charges);
  const showRefundable = hasNonNullValues(agreementdetails.refundable);

  return (
    <>
      <div className="agdtlbox" style={{position: "relative"}}>
        <div
          className="d-flex gap-1 align-items-center"
          style={{ cursor: "pointer", position: "relative", userSelect: "none" }}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            toggleVisibility()
          }}
          onKeyDown={handleKeyPress}
          tabIndex={0} // Make div focusable for keyboard events
        >
          <span className="agreebx text-muted agridtl">Agreement Details</span>
          <i className={`text-muted fa ${isOpen ? "fa-angle-up" : "fa-angle-down"}`}></i>
        </div> 

        {/* Conditionally render the Agreement Details div */}
        {isOpen && (showMonthlyCharges || showOneTimeCharges || showRefundable) && (
          <div className="agreediv">
            {/* Flex Container */}
            <div style={{ display: "flex", justifyContent: "space-between", gap: "15px" }}>
              {/* Monthly Charges Section */}
              {showMonthlyCharges && (
                <div style={{ flex: 1, borderRight: "2px dashed #d8d8d8" }}>
                  <span className="text-secondary">Monthly Charges</span>
                  <div className="pt-3">
                    {Object.entries(agreementdetails.monthly_charges)
                      .filter(([_, value]) => value !== null) // Skip null values
                      .map(([key, value]) => (
                        <p key={key}>
                          - {formatFieldName(key)}: {formatValue(key, value)}
                        </p>
                      ))}
                  </div>
                </div>
              )}

              {/* One-Time Charges Section */}
              {showOneTimeCharges && (
                <div style={{ flex: 1, borderRight: "2px dashed #d8d8d8" }}>
                  <span className="text-secondary">One-Time Charges</span>
                  <div className="pt-3">
                    {Object.entries(agreementdetails.one_time_charges)
                      .filter(([_, value]) => value !== null)
                      .map(([key, value]) => (
                        <p key={key}>
                          - {formatFieldName(key)}: {formatValue(key, value)}
                        </p>
                      ))}
                  </div>
                </div>
              )}

              {/* Refundable Section */}
              {showRefundable && (
                <div style={{ flex: 1 }}>
                  <span className="text-secondary">Refundable</span>
                  <div className="pt-3">
                    {Object.entries(agreementdetails.refundable)
                      .filter(([_, value]) => value !== null)
                      .map(([key, value]) => (
                        <p key={key}>
                          - {formatFieldName(key)}: {formatValue(key, value)}
                        </p>
                      ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default AgreementDetails;
